(function () {
  var COLLAPSED_HEIGHT = 220; // keep in sync with CSS max-height

  function initReadMore() {
    document.querySelectorAll('.hdt-product-tab__content').forEach(function (el) {
      if (el.dataset.readMoreInit) return;
      if (el.scrollHeight === 0) return; // not rendered yet, try later

      el.dataset.readMoreInit = 'true';
      if (el.scrollHeight <= COLLAPSED_HEIGHT + 10) return; // genuinely short

      el.classList.add('dsb-truncated');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dsb-read-more-btn';
      btn.textContent = 'Read more';
      el.insertAdjacentElement('afterend', btn);

      btn.addEventListener('click', function () {
        var collapsed = el.classList.toggle('dsb-truncated');
        btn.textContent = collapsed ? 'Read more' : 'Read less';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initReadMore);
  window.addEventListener('load', initReadMore);
  setTimeout(initReadMore, 500);
  setTimeout(initReadMore, 1500);
})();